import React, { useState, useEffect } from 'react';
import { TextArea, TextAreaProps } from 'carbon-components-react';

const CustomTextAreaWithCounter: React.FC<TextAreaProps> = ({
  id,
  maxLength,
  labelText,
  rows,
  helperText,
  name,
  onChange,
  onBlur,
  value
}) => {
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    if (typeof value === 'string') {
      setCharCount(value.length);
    }
  }, [value]);

  return (
    <div className="form-item">
      <label htmlFor={id} className="bx--label">
        <div>{labelText}</div>{' '}
        <div>
          {charCount}/{maxLength}
        </div>
      </label>
      <TextArea
        id={id}
        labelText={''}
        rows={rows}
        helperText={helperText}
        maxLength={maxLength}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default React.memo(CustomTextAreaWithCounter);
